import React from 'react';
import PropTypes from 'prop-types';
import './showHide.scss';
import { CheckCircle, Circle, XCircle } from '@phosphor-icons/react';
import COLORS from '../../../util/constants/colors';
import Typography from '../../Typography';
import classNames from 'classnames';

const ShowHide = ({ title, show, setShow, hideDisabled }) => {
  const hideClasses = classNames('hide', { active: !show, disabled: hideDisabled });
  const showClasses = classNames('show', { active: show });

  return (
    <div className="show-hide-container">
      <Typography variant="text" size="medium">{title}</Typography>
      <div className='show-hide'>
        <div className={showClasses} onClick={() => !show && setShow(true)}>
          {show ?
            <CheckCircle size={24} weight="fill" color={COLORS.SUCCESS_HOVER_LITE} />
            : <Circle size={24} />
          }
        </div>
        <div className={hideClasses} onClick={() => !hideDisabled && show && setShow(false)}>
          {!show ?
            <XCircle size={24} weight="fill" color={COLORS.ERROR_LITE} />
            : <Circle size={24} />
          }
        </div>
      </div>
    </div>
  );
};

ShowHide.defaultProps = {
  hideDisabled: false,
};

ShowHide.propTypes = {
  title: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  hideDisabled: PropTypes.bool,
};

export default ShowHide;
